var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2519 0H57.3789C56.8758 0 56.4121 0.279554 56.1668 0.730713L38.0168 34.1737V0.949372C38.0168 0.425327 37.6025 0 37.0922 0H26.2192C25.716 0 25.2524 0.279554 25.0071 0.730713L0.118151 46.5884C-0.225083 47.2213 0.220581 48 0.925918 48H9.43849C9.94615 48 10.4134 47.7149 10.6569 47.2573L15.0165 39.0414H27.7099V47.0506C27.7099 47.5747 28.1241 48 28.6344 48H40.5991C41.1068 48 41.574 47.7149 41.8175 47.2573L46.1771 39.0414H58.8705V47.0506C58.8705 47.5747 59.2847 48 59.795 48H68.2519C68.7623 48 69.1765 47.5747 69.1765 47.0506V0.949372C69.1765 0.425327 68.7623 0 68.2519 0ZM27.7099 29.2792H20.1964L27.275 15.9382C27.39 15.7223 27.709 15.8053 27.709 16.0517L27.7099 29.2792ZM58.8696 29.2792H51.3562L58.4347 15.9382C58.5497 15.7223 58.8687 15.8053 58.8687 16.0517L58.8696 29.2792Z",
    fill: "#00081C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f33f11328bbab512edf3c632c10375dc.svg";
export { ForwardRef as ReactComponent };